import React, { useEffect, useState } from "react";
import mainBG from "../../assets/pic/mainBG2.webp";
import whiteArrow from "../../assets/pic/whiteArrow.svg";
import grayArrow from "../../assets/pic/grayArrow.svg";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import TrendingCards from "./TrendingCards";
import Features from "./Features";
import PopularCategories from "./PopularCategories";
import HowitWorks from "./HowitWorks";
import FAQ from "./Faqs";
import Realgreeting from "./Realgreeting";
import Reviews from "./Reviews";
const Home = () => {
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [marginTop, setMarginTop] = useState(
    document.getElementById("general_nav")?.scrollHeight
  );
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // setNavigateLoader(true);
      setTimeout(() => {
        // window.location.href = "/dashboard/print";
        setLoggedIn(true);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    const generalNav = document.getElementById("general_nav");

    if (generalNav) {
      const resizeObserver = new ResizeObserver(() => {
        setMarginTop(generalNav.scrollHeight);
      });

      resizeObserver.observe(generalNav);
      return () => resizeObserver.disconnect();
    }
  }, []);
  return (
    <section>
      <div style={{ marginTop: `${marginTop}px` }} className={`relative `}>
        <div className="bg-red-400 py-2">
          <p className="text-center font-semibold text-white text-[24px] max-md:text-xs">
            {/* Limited Offer - 30% Off For Our First Customers! Code: FIRST30 */}
            {/* Limited Time Offer - Subscribe Now & Get Your First Month Free! */}
            Single card purchase only $4.95/card or Subscribe and pay only $3.25/card
          </p>
        </div>
        <img
          src={mainBG}
          alt="Landing Page"
          className="object-cover w-full h-full"
        />

        <div className="absolute max-sm:top-3.5 top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center md:p-8 text-center py-5 m-2">
          <div className="max-sm:mt-5 w-4/5 xl:w-3/5 mx-auto">
            <h1 className="landing_page_header text-xl font-semibold lg:text-6xl text-white text-center">
              Heartfelt Greeting Cards
              <br />
              <span className="text-[#F66061]">Made </span>Easy. <br />
            </h1>
            <h3 className="text-xs sm:text-sm md:text-lg lg:text-xl xl:text-2xl  text-white font-shadows font-[400] md:mt-4 text-center">
              You send the love, we do the work
            </h3>
            <div className="flex items-center gap-x-2 justify-center mt-5">
              <Link
                to={`${
                  loggedIn ? "/dashboard/card_generation" : "/browse_cards"
                }`}
              >
                <button className="rounded-md bg-[#F66061] text-white md:text-xl text-xs md:px-6 px-3 md:py-3 py-2 hover:bg-primary-dark focus:outline-none">
                  <span className="flex gap-2">
                    {" "}
                    Generate Card
                    <img src={whiteArrow} alt="" />
                  </span>
                </button>
              </Link>
              <Link to="/pricing">
                <button className="rounded-md bg-white text-[#2F3649] md:text-xl text-xs md:px-10 px-5 md:py-3 py-2 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50">
                  <span className="flex gap-2">
                    Subscribe <img src={grayArrow} alt="" />
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <HowitWorks />
      <PopularCategories />
      <Features />
      <TrendingCards />
      {/* <Realgreeting loggedIn={loggedIn} /> */}
      <Reviews />
      <FAQ />
      <Footer />
    </section>
  );
};

export default Home;

export const LayoutForLandingPage = ({ children }) => {
  return (
    <div class="w-full flex justify-center">
      <div class="w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="w-11/12 lg:w-7/10 mx-auto">{children}</div>
      </div>
    </div>
  );
};
